function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#15A9E1",
  d: "M253.62 76.78c0 26.42-25.83 49.45-64.11 61.62a192.69 192.69 0 01-32.29 7.16h-.08a220.8 220.8 0 01-29.83 1.99 223.97 223.97 0 01-24.24-1.3 204.83 204.83 0 01-18.73-2.91h-.03a183.26 183.26 0 01-17.47-4.42l-.25-.08C32 114 4 106.5 1 76.78-3.85 28.74 63.74 0 133.5 0c34.67 0 52.68 23.83 75.5 36.5 23.5 11.5 44.62 20.62 44.62 40.28z",
  opacity: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#15A9E1",
  d: "M106.13 146.56c-1.02-.1-2.04-.2-3.06-.3a204.8 204.8 0 01-15.77-2.34l-.17-17.67-.06.2c-.6 2.23-1.75 9.92-2.72 16.9h-.03a183.26 183.26 0 01-17.48-4.42l-.24-.08a200.44 200.44 0 012.23-17.14c1.6-8.92 3.25-13.85 3.39-14.26 0 0 0-.02 0-.03l2.53-1.96s12.59-7.63 21.77-7.75c4.47-.06 8.14 1.66 9.15 6.9a62.43 62.43 0 01.77 5.63 155.15 155.15 0 01.53 11.42c.09 8.83-.4 18.22-.84 24.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#19A3D6",
  d: "M86.66 115.85c1.95.04 3.93.03 5.9-.06 2.06-.08 4.12-.26 6.17-.54 1.08-.17 2.16-.39 3.22-.65a23.54 23.54 0 002.5-.78c.4-.18.8-.38 1.17-.6.15-.08.96-.68.58-.35.17-.15.34-.3.5-.46a71.1 71.1 0 00-1.02-7.79c-3.1-16.01-30.92.85-30.92.85l-2.53 1.97s-.58 2.2-1.4 5.56a52.55 52.55 0 0015.83 2.85zM87.05 126.47c-.61 2-1.77 9.8-2.75 16.88a182.96 182.96 0 01-17.47-4.41c.39-4.75.83-9.55 1.32-13.17.22-1.63.44-3.02.66-4.06 6.03 1.83 12.15 3.27 18.24 4.76z",
  opacity: 0.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F79BB",
  d: "M78.41 58.53s-5.34 0-10.68 7.3c-5.33 7.31-7.87 10.4-7.87 10.4l-9.55-11.52-7.31 4.5s12.93 21.64 16.3 21.64c3.37 0 20.25-18.27 20.25-18.27L78.4 58.53z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#236AA9",
  d: "M54.76 70.08l-4.45-5.37-7.31 4.5s2.44 4.08 5.47 8.7c2.2-2.53 4.41-5.05 6.3-7.83zM64.3 74.83a44.39 44.39 0 006.47 6.7l.04.04c4.6-4.51 8.73-8.99 8.73-8.99L78.4 58.53s-5.34 0-10.68 7.3a420.14 420.14 0 01-4.96 6.67c.47.8.98 1.58 1.54 2.33z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M46.53 76.34l7.7-7.7-2.02-1.87s3.25-13.9-1.86-1.95c0 0-9.35-20.25-3.77-2.68 0 0-8.84-15.37-1.87 1.5 0 0-9.1-13.13-1.42 1.21 0 0-7.08-9.24-2.06 1.22 5.02 10.47 5.3 10.27 5.3 10.27z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#15A9E1",
  d: "M111.58 58.25c-3.65-2.53-19.39-3.66-19.39-3.66s-17.42.27-24.6 5.25c-1.5.86-2.8 2.04-3.79 3.46 0 0 3.67 12.63 8.26 21.37.02.07.02.15.03.22.21 13.9-3.5 19.47.15 22.54 9.04 7.62 34.28 2.81 34.28 2.81s8.71-49.47 5.06-52z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M85.1 55.13a18.97 18.97 0 006.95 2.22c1.7.2 3.44.2 5.14 0 .88-.1 1.74-.32 2.56-.65a3.4 3.4 0 001.17-.78c-.63-.84-.78-2.2-.57-4.68.7-7.47-15.15-.89-15.15-.89s.45 3.22-.1 4.78z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D1D1",
  d: "M85.3 54.32c.38.14.77.27 1.16.39 2.82.76 5.76.98 8.66.66 1.25-.06 2.49-.26 3.7-.58a2.3 2.3 0 001.47-1.01c-.04-.84-.02-1.7.07-2.53.7-7.48-15.15-.9-15.15-.9.17 1.32.2 2.65.09 3.97z",
  opacity: 0.5
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#15A9E1",
  d: "M84.7 52.66s-3.9-1.33-4.95-7.43c-1.05-6.11-2.27-21.63 8.66-23.85 10.93-2.23 17.03 1.68 18.6 11.37 1.58 9.68-4.97 19.8-11.44 20.55-6.47.74-10.88-.64-10.88-.64z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#1C9CCC",
  d: "M107.02 32.75c-.66-4.08-2.13-7.11-4.4-9.12.25 1.27.3 2.56.14 3.84a23.6 23.6 0 01-2.79 8.82 8.73 8.73 0 01-2.94 3.29 23.2 23.2 0 01-3.38 1.62c-.39 4.1-.71 8.21-1.17 12.3.96-.01 2-.08 3.1-.2 6.46-.75 13.01-10.87 11.44-20.55z",
  opacity: 0.5
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#D67D4A",
  d: "M93.52 27.27s-9.17-2.05-11.74 6.23c-2.58 8.27-1.2 18.59 7.68 19.66 8.88 1.08 11.77-6.5 12.6-14.3.83-7.8-4.89-11.47-8.54-11.6z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#C97A79",
  d: "M96.16 27.88c1 1.4 1.85 2.9 2.5 4.5 1.17 3.08.75 6.66-.78 9.55-2.7 5.09-8.32 6.16-13.6 6.29a3.2 3.2 0 01-2.54-1.03 9.15 9.15 0 007.73 5.98c8.88 1.08 11.77-6.5 12.6-14.3.64-6.07-2.69-9.64-5.9-10.99z",
  opacity: 0.6
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#C97A79",
  d: "M89.94 34.74c-.08.85-.2 1.69-.37 2.52a43.7 43.7 0 01-2.09 7.32c.08-.85.2-1.69.37-2.52a43.72 43.72 0 012.09-7.32z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M89.84 37.63c-2.68-.3-6.48 1.9-9.16 1.67-.47 6.67 1.9 13.03 8.78 13.87 7.89.96 11.05-4.91 12.24-11.68-4.33-.45-7.54-3.37-11.86-3.86z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D1D1",
  d: "M97.89 40.49c-.81 4.5-3.29 9.1-7.79 10.23-2.06.48-4.2.42-6.23-.19a9.14 9.14 0 005.58 2.64c7.9.96 11.05-4.91 12.24-11.68-1.3-.16-2.59-.5-3.8-1z",
  opacity: 0.5
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#15A9E1",
  d: "M189.13 72.37s2.66 24.74 5.15 35.4c2.48 10.64-8.64 13.11-12.8 8.3-4.14-4.82-2.16-29.9-1.66-43.03.5-13.13 9.3-.67 9.3-.67z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#1C9CCC",
  d: "M189.84 78.64a35.76 35.76 0 01-6.93 5.28 56.3 56.3 0 01-3.67 1.95c-.54 12.53-.78 26.7 2.25 30.2 4.15 4.82 15.28 2.34 12.79-8.3-1.7-7.26-3.48-21.07-4.44-29.13z",
  opacity: 0.7
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F79BB",
  d: "M174.17 111.94l26.7-12.1 6.53 20.93-26.12 10.57-7.1-19.4z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M177.05 112.85l22.53-10.2 5.52 17.66-22.05 8.91-6-16.37z",
  opacity: 0.8
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M190.65 122.66a94.49 94.49 0 00-3.2-16.75l-13.28 6.02 7.1 19.4 9.82-3.96c-.13-1.57-.27-3.15-.44-4.71z",
  opacity: 0.1
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M189.58 128.12s.1-8.1 1.13-.75c0 0 .39-8.57 1.5-.57 0 0 .66-6.78 1.23-.47 0 0 1.6-7.62 1.03-.47 0 0-.75 5.08-5.55 4.14l-.28-1.7 1.31-.56-.37.38z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#15A9E1",
  d: "M189.5 138.39a192.72 192.72 0 01-32.28 7.16h-.08c-4.43.6-8.95 1.07-13.55 1.4.93-10.44 3.02-23.98 4.78-34.42a917 917 0 011.9-10.84c.1-.54.19-1.04.28-1.5.41-2.27.67-3.63.7-3.74l1.85-1.24.28-.19 1.85-1.23a31.78 31.78 0 015.13-6.11c4.78-4.4 12.13-7.87 18.7 2.8a39.8 39.8 0 012.76 5.47 73.5 73.5 0 013.46 10.94c.16.67.32 1.34.47 2.01.69 3.1 1.26 6.29 1.75 9.5.43 2.87.78 5.75 1.1 8.56.03.43.08.86.12 1.29 0 .01 0 .03 0 .05.03.39.07.74.1 1.11.3 3.16.52 6.18.69 8.98z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#1AA0D2",
  d: "M153.27 100.82c4.46.85 9 1.09 13.52.72 3.3-.26 7.31-.89 10.26-2.25a14 14 0 004.85-3.43 73.75 73.75 0 00-2.06-4.05c-10.97-19.94-24.6 2-24.6 2l-3.98 2.65s-.58 1.32-1.42 3.57c1.13.3 2.28.56 3.43.79z",
  opacity: 0.7
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "#15A9E1",
  d: "M154.96 58.48s-6.37 3.76-9.35 4.76c-2.97 1-4.81 7.64-4.98 13.63-.17 5.98 10.63 19.6 10.63 19.6s23.72 2.48 29.4-2.99c4.5-4.32 4.33-10.8 1.34-18.44l7.47 2.5s.67-11.8-5.48-13.64c-3.4-1-13.12-1-13.29-7.78-.17-6.8-15.74 2.36-15.74 2.36z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M171.16 58.66a19.38 19.38 0 01-7.23 1.85c-1.75.1-3.51 0-5.24-.32a9.94 9.94 0 01-2.58-.83c-.44-.2-.84-.5-1.16-.88.69-.8.94-2.2.86-4.72-.26-7.67 15.52 0 15.52 0s-.62 3.27-.18 4.9z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D1D1",
  d: "M171.03 57.83c-.4.1-.82.21-1.23.3-2.92.6-5.93.66-8.88.16a18.3 18.3 0 01-3.73-.82 2.37 2.37 0 01-1.45-1.12c.1-.86.12-1.72.08-2.59-.26-7.67 15.52 0 15.52 0a18.8 18.8 0 00-.31 4.07z",
  opacity: 0.5
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fill: "#15A9E1",
  d: "M171.7 56.57s4.11-.93 5.84-7.01c1.73-6.08 4.64-21.75-6.23-25.2-10.87-3.44-17.5-.13-20.15 9.55-2.65 9.68 2.92 20.69 9.41 22.14 6.5 1.46 11.13.52 11.13.52z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fill: "#1C9CCC",
  d: "M166.8 45.6c-2.66-.19-5.35-.49-7.82-1.57a16.05 16.05 0 01-5.55-4.15 25.6 25.6 0 01-2.73-3.82c-1.35 9.08 3.85 18.61 9.87 19.98 6.5 1.46 11.13.53 11.13.53s4.11-.93 5.84-7.01a48.4 48.4 0 001.43-7.15 18.8 18.8 0 01-12.16 3.18z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "#D67D4A",
  d: "M165.47 29.79s9.55-1.09 11.27 7.61c1.72 8.7-.78 19.03-9.94 19.17-9.16.13-11.27-7.89-11.27-15.92 0-8.02 6.23-11.13 9.94-10.86z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fill: "#15A9E1",
  d: "M161.09 34.9c4.37.5 8.8.9 13.2.73 1.6-.05 3.2-.22 4.77-.5-.55-4.79-2.61-9.15-7.76-10.78-10.56-3.35-17.13-.31-19.92 8.75 3.24.6 6.43 1.43 9.7 1.8z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M168.6 40.9c2.76-.03 5.88 2.46 8.63 2.51-.25 6.84-3.35 13.05-10.43 13.16-8.13.12-10.7-6.2-11.18-13.24 4.45.05 8.53-2.4 12.99-2.44z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D1D1",
  d: "M159.76 42.64c.23 3.03.78 7.08 3.14 9.19a14.53 14.53 0 008.77 3.43 9.64 9.64 0 01-4.87 1.3c-8.13.13-10.7-6.18-11.18-13.23 1.32.05 2.65.05 4.14-.7z",
  opacity: 0.5
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F79BB",
  strokeMiterlimit: 10,
  strokeWidth: 1.24,
  d: "M162.14 45.18a4.5 4.5 0 100-8.98 4.5 4.5 0 000 8.98zM177.74 43.35a4.5 4.5 0 10-8.31-3.41 4.5 4.5 0 008.31 3.41z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF3F5",
  stroke: "#236AA9",
  strokeMiterlimit: 10,
  strokeWidth: 1.24,
  d: "M162.14 45.18a4.5 4.5 0 100-8.98 4.5 4.5 0 000 8.98zM177.74 43.35a4.5 4.5 0 10-8.31-3.41 4.5 4.5 0 008.31 3.41z",
  opacity: 0.2
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  stroke: "#236AA9",
  strokeMiterlimit: 10,
  strokeWidth: 1.24,
  d: "M166.62 41.04s1.81-.57 2.59 0M157.64 40.85l-2.16-.5M178.16 41.47l-.95-.17"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  fill: "#24B6ED",
  d: "M148 62.1c-1.57 2.94-2.92 6.18-3.42 9.4.26.17.47.42.58.72 1.56 4.67.52 30.11 2.33 30.37 1.82.26 9.87-4.15 9.6-10.9-.24-6.55-.98-26.3-9.1-29.6z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  fill: "#ABCDD3",
  d: "M155.97 78.42c-.72.74-1.46 1.46-2.2 2.15-2.52 2.33-5.03 4.67-7.59 7 .18 7.53.33 14.9 1.3 15.03 1.82.26 9.87-4.15 9.6-10.9-.11-4.44-.49-8.88-1.11-13.28z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fill: "#24B6ED",
  d: "M157.14 145.57a220.02 220.02 0 01-29.83 1.99 224.3 224.3 0 01-24.25-1.3c.13-8.4 1.98-16.84 3.9-24.59 1.43-5.76 2.9-11.14 3.74-15.82.9-5.02 1.07-9.24-.3-12.3a22.89 22.89 0 01-.86-2.29c-.05-.14-.08-.26-.12-.38a21.03 21.03 0 01-.77-3.75 31.44 31.44 0 01-.23-4.43c0-.31 0-.63.03-.94 0-.13 0-.27.02-.4l.02-.36c.03-.32.05-.63.08-.95l.05-.49c0-.02 0-.05 0-.07.02-.25.05-.5.08-.74l.1-.73c.04-.33.1-.66.15-.99a45.5 45.5 0 012.64-9.57l.73.03 27.07 1.13 2.48.1 3.3.14 3.8.16a221.62 221.62 0 012.48 13.7 157.81 157.81 0 01.38 2.62c.42 2.95.82 6 1.17 9.09l.09.77.16 1.42a1067.03 1067.03 0 01.47 4.27 880.26 880.26 0 013.42 44.69z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fill: "#1BADE3",
  d: "M154.85 108.5a825.13 825.13 0 012.37 37.06h-.08a220.02 220.02 0 01-29.83 1.99 223.97 223.97 0 01-24.24-1.3c.13-8.4 1.98-16.84 3.89-24.59 1.43-5.76 2.9-11.14 3.74-15.83.9-5 1.08-9.23-.3-12.3a21.94 21.94 0 01-.86-2.28c-.04-.14-.08-.26-.12-.39a22.08 22.08 0 01-.77-3.74 31.44 31.44 0 01-.23-4.43c0-.31 0-.63.03-.94a3 3 0 01.02-.41l.03-.35c.02-.32.04-.64.07-.95l.05-.49c0-.02 0-.05 0-.08.03-.24.05-.49.08-.74l.1-.72a34.49 34.49 0 01.5-2.88 52.43 52.43 0 003.58 3.64c.78.71 1.58 1.4 2.4 2.04 4.93 3.9 10.51 6.65 16.44 8.72a99.9 99.9 0 0021.27 4.9l.3.04a101.52 101.52 0 00.28 2.18 243.45 243.45 0 01.5 4.3c.3 2.46.55 4.99.78 7.55z",
  opacity: 0.5
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  fill: "#24B6ED",
  d: "M125.36 94.9c-3.64.26-17.06-2.52-17.06-3.2 0-4.45 5.53-16.7 5.53-16.7s29.77-7.45 31.33-2.78c.27 1 .44 2.02.52 3.05a51.81 51.81 0 007.81-6.58c-1.43-3.47-3.43-6.11-6.25-6.86-8.83-2.34-11.77.52-11.51-7.27.26-7.79-15.75 0-15.75 0s1.12 5.89-.7 5.89c-1.81 0-13.58-3.03-16.7 4.24-3.11 7.27-9.08 33.74-4.4 37.9 4.66 4.15 30.29 5.28 31.85-.7 1.55-5.97-1.04-7.25-4.67-6.98z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  fill: "#236AA9",
  d: "M149.35 88.62a.5.5 0 00.36.57.49.49 0 00.66-.17l7.9-19.94c.1-.2-.07-.47-.35-.57a.5.5 0 00-.66.17l-7.9 19.94z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F79BB",
  d: "M137.55 78.84l-7.1 31.96 23.19 2.27 8.3-31.33-24.4-2.9z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M129.76 96.62s9.51-10.38 3.46-.69c0 0 21.46-1.38.69 1.9 0 0 20.94 1.91-.35 1.74 0 0 17.83 3.11-.52 1.55 0 0 16.8 3.81-2.25 1.39-19.04-2.42-1.03-5.89-1.03-5.89z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  fill: "#ABCDD3",
  d: "M132.01 102.46c-.55-2.28-.96-4.6-1.22-6.94-.61.64-1.03 1.1-1.03 1.1s-18 3.46 1.03 5.89l1.27.16-.05-.21z",
  opacity: 0.5
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  fill: "#24B6ED",
  d: "M125.36 94.9c-3.64.26-14.8-2.26-14.8-2.95 0-4.44 3.26-16.95 3.26-16.95s16.02-4.01 25.17-4.3a33.87 33.87 0 013.18-9.83c-4.92-.63-6.66-.25-6.46-6.3.26-7.79-15.75 0-15.75 0s1.13 5.88-.7 5.88c-1.81 0-13.58-3.03-16.7 4.24-3.1 7.27-9.08 33.75-4.4 37.9 4.67 4.16 30.3 5.28 31.85-.69 1.56-5.97-1.02-7.26-4.65-7z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M120.15 59.54a19.6 19.6 0 007.33 1.88c1.78.1 3.57-.02 5.33-.34.9-.15 1.78-.43 2.6-.83.45-.21.85-.52 1.17-.9-.7-.82-.96-2.23-.87-4.78.26-7.79-15.75 0-15.75 0s.65 3.31.19 4.97z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D1D1",
  d: "M120.3 58.69a24.26 24.26 0 0010.25.48 18.8 18.8 0 003.79-.84 2.4 2.4 0 001.46-1.14 16.8 16.8 0 01-.07-2.62c.26-7.79-15.75 0-15.75 0 .25 1.36.36 2.74.32 4.12z",
  opacity: 0.5
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  fill: "#24B6ED",
  d: "M119.61 57.4s-4.17-.95-5.92-7.13c-1.75-6.19-4.7-22.06 6.33-25.56 11.03-3.5 17.75-.14 20.44 9.68 2.7 9.82-2.96 20.99-9.55 22.47-6.6 1.48-11.3.54-11.3.54z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  fill: "#1BADE3",
  d: "M140.46 34.42c-1.13-4.12-2.97-7.09-5.54-8.91.4 1.27.58 2.6.57 3.94a24.51 24.51 0 01-1.92 9.4 9.05 9.05 0 01-2.67 3.73 24.33 24.33 0 01-3.31 2.04c.06 4.28.17 8.56.15 12.85 1-.13 2.06-.31 3.17-.56 6.6-1.51 12.24-12.68 9.55-22.49z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  fill: "#D67D4A",
  d: "M125.93 30.24s-9.68-1.1-11.43 7.72c-1.76 8.83.8 19.32 10.09 19.45 9.28.14 11.43-8 11.43-16.14s-6.32-11.3-10.09-11.03z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M122.38 44.09c-2.8 0-5.59-.08-8.38 0 .25 6.93 3.4 13.24 10.59 13.34 8.24.13 10.86-6.28 11.34-13.41-4.52.03-9.04.1-13.56.07z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D1D1",
  d: "M131.91 44.05c-.23 3.07-.98 6.42-3.37 8.56a14.75 14.75 0 01-8.9 3.48c1.5.87 3.21 1.32 4.95 1.3 8.24.13 10.86-6.27 11.34-13.4l-4.02.06z",
  opacity: 0.5
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  fill: "#136060",
  d: "M135.1 37.78c-1.71-.86-3.93-.92-5.81-1.02-2.66-.1-5.32-.07-7.97.11-1.85.1-3.7.25-5.54.42-1.66.16-2.96 1.1-3.29 2.81-.34 2.92-.1 7.01 2.64 8.76 1.55 1 3.8.73 5.2-.39.72-.6 1.36-1.3 1.9-2.06.5-.63 1.22-2 2.14-1.5.78.42 1.4 1.21 2.02 1.83.75.78 1.58 1.48 2.49 2.08a4.89 4.89 0 005.34.02c1.92-1.3 2.42-4.42 2.52-6.53.07-1.66 0-3.7-1.64-4.53z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  fill: "#187C7E",
  d: "M112.06 40.01c.41-2.05 2.16-2.25 3.86-2.4 2.05-.17 4.1-.3 6.16-.39 2.34-.11 4.68-.08 7.02.09 1.42.12 3.96.19 4.97 1.42 1.63 1.99.6 6.54-.53 8.56-2.08 3.74-5.73 1.01-7.79-1.03-.8-.78-1.82-2.17-3.11-1.97-1.3.2-2.1 1.85-2.88 2.77-2.64 3.11-6.3 1.94-7.35-1.79a14 14 0 01-.35-5.26c.04-.32-.75-.18-.78.1-.42 3.62.33 9.56 5.16 9.34 2.42-.1 3.7-2.03 5.09-3.72 1.16-1.42 1.88-.78 2.99.32.96.94 1.9 1.95 3.05 2.67 5.96 3.7 9.13-4.7 7.64-9.4-.54-1.7-2.4-2.03-3.98-2.28a44 44 0 00-8.04-.28c-2.67.07-5.33.25-8 .5-1.88.17-3.5.78-3.9 2.86-.07.3.72.17.77-.1z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  fill: "#C4EFFF",
  d: "M111.67 40.06s.39-2.3 2.42-2.5c2.04-.19 19.38-1.94 20.59 1.42 1.21 3.37-.08 8.89-2.29 9.96-4.7 2.29-7.79-4.71-9.68-4.44-1.9.27-3.1 5.78-7.54 4.57-4.44-1.2-3.5-9.01-3.5-9.01z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  fill: "#187C7E",
  d: "M112.06 40.01c.41-2.05 2.16-2.25 3.86-2.4 2.05-.17 4.1-.3 6.16-.39 2.34-.11 4.68-.08 7.02.09 1.42.12 3.96.19 4.97 1.42 1.63 1.99.6 6.54-.53 8.56-2.08 3.74-5.73 1.01-7.79-1.03-.8-.78-1.82-2.17-3.11-1.97-1.3.2-2.1 1.85-2.88 2.77-2.64 3.11-6.3 1.94-7.35-1.79a14 14 0 01-.35-5.26c.04-.32-.75-.18-.78.1-.42 3.62.33 9.56 5.16 9.34 2.42-.1 3.7-2.03 5.09-3.72 1.16-1.42 1.88-.78 2.99.32.96.94 1.9 1.95 3.05 2.67 5.96 3.7 9.13-4.7 7.64-9.4-.54-1.7-2.4-2.03-3.98-2.28a44 44 0 00-8.04-.28c-2.67.07-5.33.25-8 .5-1.88.17-3.5.78-3.9 2.86-.07.3.72.17.77-.1z"
});

var SvgHealthWorkers = function SvgHealthWorkers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 148,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHealthWorkers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/health-workers.fa288a44.svg";
export { ForwardRef as ReactComponent };